import api from './api';

/**
 * Événement de parcours (table user_events, cf. backend/lib/UserEvents.php).
 * Fire-and-forget : un échec ne doit jamais gêner l'utilisateur.
 *
 *   trackEvent('paywall_shown', { source: 'melange', scopeId: 2 });
 *
 * visit_id relie les événements d'un même onglet (sessionStorage, rien de persistant).
 * Le serveur ignore les doublons rapprochés (double rendu, double clic) et l'admin en simulation.
 */
function visitId() {
    try {
        let v = sessionStorage.getItem('mq_visit');
        if (!v) {
            v = Array.from(crypto.getRandomValues(new Uint8Array(8)), b => b.toString(16).padStart(2, '0')).join('');
            sessionStorage.setItem('mq_visit', v);
        }
        return v;
    } catch {
        return undefined;
    }
}

export default function trackEvent(event, { source, scopeId, refId, meta } = {}) {
    if (!event) return;
    api.post('/user/event.php', {
        event,
        source: source || undefined,
        scope_id: scopeId || undefined,
        ref_id: refId || undefined,
        visit_id: visitId(),
        meta: meta || undefined,
    }).catch(() => { /* fire-and-forget */ });
}
